import { Close } from "@mui/icons-material";
import { Alert, IconButton, Snackbar, Stack, Typography } from "@mui/material";
import { useLanguage } from "inspector-common/lib/language";
import { useState } from "react";

interface BetaWarningProps {};

export default function BetaWarning(props: BetaWarningProps) {
    const language = useLanguage();
    const [open, setOpen] = useState(true);

    return <Snackbar open={open} onClose={() => setOpen(false)}>
        <Alert variant="filled" severity="warning" sx={{alignItems: "center"}}>
            <Stack direction="row" spacing={4} alignItems={"center"}>
                <Typography>{language.generic.betaWarning}</Typography>
                <IconButton onClick={() => setOpen(false)}>
                    <Close htmlColor={"#000000"}/>
                </IconButton>
            </Stack>
        </Alert>
  </Snackbar>
}